import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../_services/app.service';

@Component({
  selector: 'app-new-approval',
  templateUrl: './new-approval.component.html',
  styleUrls: ['./new-approval.component.scss']
})
// Added by priya - 11/11/2025
export class NewApprovalComponent implements OnInit {

  ApprovalType: string = '';
  ReferenceId: string = '';
  Amount: number = 0;
  UserId: string = '';
  Action: string = '';
  Payload: any = {};
  CompanyId: string = '';

  constructor(
    private _appService: appService,
    private toastr: ToastrService,
    private _activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.UserId = this._activatedRoute.snapshot.queryParams["UserId"];
      this.ReferenceId = this._activatedRoute.snapshot.queryParams["ReferenceId"];
      this.ApprovalType = this._activatedRoute.snapshot.queryParams["ApprovalType"];
      this.Amount = this._activatedRoute.snapshot.queryParams["Amount"];
      this.Action = this._activatedRoute.snapshot.queryParams["Action"];
      this.CompanyId = this._activatedRoute.snapshot.queryParams["CompanyId"];

      if (this.ReferenceId !== undefined && this.ReferenceId !== null && this.Action !== undefined && this.Action !== null
        && this.Amount !== undefined && this.Amount !== null && this.ApprovalType !== undefined && this.ApprovalType !== null && this.UserId !== undefined && this.UserId !== null) {
        this.ApprovalRequest(this.UserId, this.ReferenceId, this.ApprovalType, this.Amount, this.Action, this.CompanyId);
      }
    });
  }

  ApprovalRequest(UserId, ReferenceId, ApprovalType, Amount, Action, CompanyId){
    if(ApprovalType == 'Assigned Vehicle'){
      this.Payload.ReferenceId = ReferenceId;
      this.Payload.ApprovalType = ApprovalType;
      this.Payload.UserId = UserId;
      this.Payload.Amount = Amount;
    } else if (ApprovalType == 'Product Rate'){
      // payload for product rate 
    } else if (ApprovalType == 'Expenses'){
      // Payload for expense
    } else {
      this.toastr.error("Approval Type is missing", 'error');
      return;
    }

    if(Action == 'Approve'){
      this._appService.Post("Booking", "OnApproveRequest", this.Payload).subscribe(
        (response) => {
          this.toastr.success('Successfully Approved!', 'Ok');
          if( response.length > 0 && response[0] && response[0].Message && typeof response[0].Message === 'string' && response[0].Message.toLowerCase() === 'no manager found'){
            if(ApprovalType === 'Expenses'){
              this.AuthorizeExpense(ReferenceId, CompanyId);
            }
          }
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
        }
      );
    } else if(Action == 'Reject'){
      this._appService.Post("Booking", "OnRejectRequest", this.Payload).subscribe(
        (response) => {
          this.toastr.success('Successfully Rejected!', 'Ok');
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !","error");
        }
      );
    } else {
      this.toastr.error("Action is missing", 'error');
    }
  }

  AuthorizeExpense(Id, CompanyId) {
    this._appService.GetByThreeId("Common", "AuthorizeTransaction", 4, Id, CompanyId).subscribe(
      (response) => {
        this.PostData(Id, CompanyId)
      },
      (err) => {
        this.toastr.error("An error occured  !", "error");
      }
    );
  }

  PostData(Id, CompanyId) {
    this._appService.GetByThreeId("Expense", "PostExpense", Id, CompanyId, null).subscribe(
      (response) => {
        this.toastr.success("Expense Posted Successfully !", "Success");
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
      }
    );
  }

}
